import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useStoryActions} from '../../../../entities';

interface PublishStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  storyId: string;
  refetchStory: () => void;
}

export const PublishStoryModal = ({open, setOpen, storyId, refetchStory}: PublishStoryModalProps) => {
  const {publishStoryMutation} = useStoryActions();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Публикация истории',
    title: 'Ошибка при публикации истории',
  });

  useEffect(() => {
    if (publishStoryMutation.error) {
      handleError(publishStoryMutation.error as unknown as ApiError);
    }
  }, [publishStoryMutation.error, handleError]);

  const handlePublish = async () => {
    try {
      await publishStoryMutation.mutateAsync(storyId);
      refetchStory();
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handlePublish}
        isLoading={publishStoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Публикация истории'}
        textButtonApply={'Опубликовать'}
        textButtonCancel={'Отменить'}
        viewActionButton="action">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите опубликовать эту историю?
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
